import React from 'react'

import { useGeolocated } from 'react-geolocated'

import { GeoLocationContext } from '../context/GeoLocationContext'

import type { UseGeoLocationReturn } from '../helpers/types/hooks/geolocation.types'

export function useGeoLocation(): UseGeoLocationReturn {
  const context = React.useContext(GeoLocationContext)

  useGeolocated({
    positionOptions: {
      enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
    onSuccess,
    onError: positionError =>
      console.log(
        'Geolocation error: ',
        positionError,
        'Default Location',
        context.location
      ),
  })

  async function onSuccess(position: GeolocationPosition): Promise<void> {
    context.setUserLocation({
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    })

    if (
      context.location.lat === -19.9262762 &&
      context.location.lng === -43.938171
    ) {
      context.setLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      })
    }
  }

  function setLocation(coords: google.maps.LatLngLiteral | undefined): void {
    if (coords !== undefined) {
      context.setLocation(coords)
    }
  }

  function setUserLocation(
    coords: google.maps.LatLngLiteral | undefined
  ): void {
    if (coords !== undefined) {
      context.setUserLocation(coords)
    }
  }

  return {
    location: context.location,
    setLocation,
    userLocation: context.userLocation,
    setUserLocation,
  }
}
